export default "__VITE_ASSET__7qfKWTU6__"